import { gql } from '@apollo/client';

export const INSURANCE_CONVENTION_QUERY = gql`
  query insuranceConvention($productId: Int!) {
    insuranceConvention(productId: $productId) {
      productId
      productCode
      productName
      isActive
      currencyId
      currencyCode
      startDate
      endDate
      productPeriod
      defaultProductPeriod
      trackingTypeId
      insuranceTypeId
      insuredAmountTypeId
      insuranceAmountId
      conventionTypeId
      insuranceValueFormula
      amountTypeFormula
      validateInsuredAmount
      roundInsuredAmount
      roundInsuranceAmount
      roundInsuranceRate
      baseInsurancePercentFormula
      genericFilterTemplateId
      minInsuranceAmount
    }
  }
`;

export const INSURANCE_CONVENTION_TYPES_QUERY = gql`
  query insuranceConventionTypes {
    insuranceConventionTypes {
      id
      name
    }
  }
`;

export const INSURANCE_TRACKING_TYPES_QUERY = gql`
  query insuranceTrackingTypes {
    insuranceTrackingTypes {
      id
      name
    }
  }
`;

export const INSURANCE_AMOUNT_TYPES_QUERY = gql`
  query insuranceAmountTypes {
    insuranceAmountTypes {
      id
      name
    }
  }
`;

export const LEASING_INSURED_AMOUNT_TYPES_QUERY = gql`
  query leasingInsuredAmountTypes {
    leasingInsuredAmountTypes {
      id
      name
    }
  }
`;

export const INSURANCE_TYPES_QUERY = gql`
  query insuranceTypes {
    insuranceTypes {
      id
      name
    }
  }
`;

// #region Risks

export const INSURANCE_CONVENTION_RISKS = gql`
  query insuranceConventionRisks($productId: Int!) {
    insuranceConventionRisks(productId: $productId) {
      productId
      insuranceTypeId
      insuranceTypeName
      riskTypeId
      riskTypeName
      riskPercent
      riskAmount
      defaultYN
      mandatoryYN
      readOnlyYN
    }
  }
`;

export const INSURANCE_CONVENTION_RISK_TYPES = gql`
  query insuranceConventionRiskTypes {
    insuranceConventionRiskTypes {
      id
      name
    }
  }
`;

// #endregion

export const INSURANCE_CONVENTION_COMMISSIONS_QUERY = gql`
  query insuranceConventionCommissions($productId: Int!) {
    insuranceConventionCommissions(productId: $productId) {
      productId
      insuranceTypeId
      insuranceTypeName
      commission
    }
  }
`;

// #region Usage Table

export const INSURANCE_USAGE_GRIDS = gql`
  query insuranceUsageGrids($productId: Int!, $categoryId: Int!) {
    insuranceUsageGrids(productId: $productId, categoryId: $categoryId) {
      id
      productId
      categoryId
      age
      usagePercent
      insurancePercent
    }
  }
`;

export const CASCO_CATEGORIES = gql`
  query cascoCategories {
    cascoCategories {
      id
      code
      name
    }
  }
`;

// #endregion

// #region Deductible Costs

export const INSURANCE_CONVENTION_DEDUCTIBLE_COSTS = gql`
  query insuranceConventionDeductibleCosts($productId: Int!) {
    insuranceConventionDeductibleCosts(productId: $productId) {
      deductibleCostId
      productId
      damageTypeId
      damageTypeName
      deductibleCostPercent
      deductibleCostAmount
      currencyId
      currencyCode
    }
  }
`;

export const INSURANCE_CONVENTION_DAMAGE_TYPES = gql`
  query damageTypes {
    damageTypes {
      id
      name
    }
  }
`;

// #endregion

export const INSURANCE_CONVENTION_INSURERS = gql`
  query insuranceConventionInsurers($productId: Int!) {
    insuranceConventionInsurers(productId: $productId) {
      productId
      insurerId
      insurerName
      isDefault
    }
  }
`;

export const INSURERS = gql`
  query insurersList {
    insurersList {
      id
      name
    }
  }
`;
export const INSURANCE_CONVENTION_ITEM_TYPES_QUERY = gql`
  query insuranceConventionItemTypes($productId: Int!) {
    insuranceConventionItemTypes(productId: $productId) {
      productId
      itemTypeId
      itemTypeName
    }
  }
`;

export const ITEM_TYPES_DICTIONARY_QUERY = gql`
  query itemTypes {
    itemTypes {
      id
      name
    }
  }
`;

export const INSURANCE_CONVENTION_ADDITIONAL_DATA = gql`
  query insuranceConventionAdditionalData($productId: Int!) {
    insuranceConventionAdditionalData(productId: $productId) {
      insuranceConventionAdditionalDataId
      additionalDataTypeId
      additionalDataTypeName
      detailId
      detailName
      insuranceConventionId
      relativePercent
      percentFormula
      isDefault
      genericFilterTemplateId
      amount
      amountFormula
    }
  }
`;

export const INSURANCE_ADDITIONAL_DATA__TYPES = gql`
  query insuranceAdditionalDataTypes {
    insuranceAdditionalDataTypes {
      additionalDataTypeId
      additionalDataTypeName
      allowMultipleDetails
    }
  }
`;

export const INSURANCE_ADDITIONAL_DATA__TYPE__DETAILS = gql`
  query insuranceAdditionalDataTypeDetails($additionalDataTypeId: Int!) {
    insuranceAdditionalDataTypeDetails(additionalDataTypeId: $additionalDataTypeId) {
      additionalDataTypeId
      detailId
      detailName
    }
  }
`;
